import React, { Component } from 'react';
import Header from '../../Components/HeadText/Head';
import './style.css';

export default class Demo extends Component {
  render() {
    return (
      <div className='demoCont'>
        <div className='container' id='demo'>
          <h2 className="title">Now It's Demo Time</h2>
          <hr />
          <div className='iframCont'>
            <div className='text-center'>
              <iframe
                className='resIframe'
                height='550vh'
                src={this.props.demoUrl}
                frameBorder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
